import { getSectionIndex, getIsSectionBoxedHelper
// @ts-expect-error no declarations found for module
} from 'EmailEditorUI/redux/selectors/sectionSelectors';
// @ts-expect-error no declarations found for module
import { getLayoutSettings } from 'EmailEditorUI/redux/selectors/styleSettingsSelectors';
import { useAppSelector } from 'EmailEditorUI/redux';
function useIsSectionBoxed(section) {
  const layoutSettings = useAppSelector(getLayoutSettings);
  return useAppSelector(state => {
    if (!section) {
      return false;
    }
    return getIsSectionBoxedHelper(layoutSettings, getSectionIndex(state, section.get('id')));
  });
}
export default useIsSectionBoxed;